import React, { createContext, useContext, useState, ReactNode } from 'react';

export type Currency = 'USD' | 'AED';

interface CurrencyContextType {
    currency: Currency;
    setCurrency: (currency: Currency) => void;
    toggleCurrency: () => void;
}

const CurrencyContext = createContext<CurrencyContextType | undefined>(undefined);

export const CurrencyProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [currency, setCurrency] = useState<Currency>('USD');

    const toggleCurrency = () => {
        setCurrency(prev => prev === 'USD' ? 'AED' : 'USD');
    };

    return (
        <CurrencyContext.Provider value={{ currency, setCurrency, toggleCurrency }}>
            {children}
        </CurrencyContext.Provider>
    );
};

export const useCurrency = () => {
    const context = useContext(CurrencyContext);
    if (!context) {
        throw new Error('useCurrency must be used within a CurrencyProvider');
    }
    return context;
};
